import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-shell" }

import AppVersion from "@/components/AppVersion.vue";
import ScrollHint from "@/components/ScrollHint.vue";
import { onMounted, onUnmounted, ref } from "vue";
import { startResizeReporter } from "@/utils/iframeResize";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "v5f3ea87b": (_unref(backgroundColor))
}))

let backgroundColor = ref("#ffffff");
const primaryButtonColor = ref<string | undefined>();

function setBackgroundColor(background: string) {
  backgroundColor.value = background;
}

function setPrimaryButtonColor(color?: string) {
  primaryButtonColor.value = color;
}

/**
 * Sync a concrete pixel viewport height for Android WebViews where
 * height:100% / vh can collapse to 0 until a definite size exists.
 */
function syncAppHeight() {
  const height =
    window.visualViewport?.height ||
    window.innerHeight ||
    document.documentElement.clientHeight;
  if (height > 0) {
    document.documentElement.style.setProperty("--app-height", `${height}px`);
  }
}

// Set as early as possible (before paint when the module evaluates).
syncAppHeight();

onMounted(() => {
  syncAppHeight();
  window.addEventListener("resize", syncAppHeight);
  window.visualViewport?.addEventListener("resize", syncAppHeight);
  startResizeReporter();
});

onUnmounted(() => {
  window.removeEventListener("resize", syncAppHeight);
  window.visualViewport?.removeEventListener("resize", syncAppHeight);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view, {
        class: "view",
        onSetBackgroundColor: setBackgroundColor,
        onSetPrimaryButtonColor: setPrimaryButtonColor
      })
    ]),
    _createVNode(AppVersion),
    _createVNode(ScrollHint, { "primary-button-color": primaryButtonColor.value }, null, 8, ["primary-button-color"])
  ], 64))
}
}

})